import { render, staticRenderFns } from "./LiquidacionObservadaDetalleProveedor.vue?vue&type=template&id=8c7ace56&scoped=true&"
import script from "./LiquidacionObservadaDetalleProveedor.vue?vue&type=script&lang=js&"
export * from "./LiquidacionObservadaDetalleProveedor.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionObservadaDetalleProveedor.vue?vue&type=style&index=0&id=8c7ace56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7ace56",
  null
  
)

export default component.exports